import _ from 'lodash'

import Generator from './generator'
import {ROUTE_TYPES} from '../../routes'


const itinPath = function() {
    return
}

export let DeepLink = {
    segment: Generator,

    new: function(...segments) {
        const hasItin = _.get(_.first(segments), 'type') === ROUTE_TYPES.ITINERARY

        return {
            path: function() {
                const pathSegments = hasItin ? segments.slice(1) : segments
                return _.map(pathSegments, (seg) => `${seg.type}.${seg.identifier}`).join('/')
            },

            baseUrl: function() {
                let itinGuid = hasItin ? _.first(segments).identifier : window.payload.itinerary.guid
                return `/trips/${window.payload.trip.guid}/itinerary/${itinGuid}/`
            },

            url: function() {
                return `${this.baseUrl()}#${this.path()}`
            },

            isCurrentItinerary: function() {
                if (!hasItin) {
                    return true
                }

                return _.first(segments).identifier === window.payload.itinerary.guid
            },

            serialize: function() {
                return segments
            }
        }
    },

    parse: function(raw) {
        if (raw.path) {
            return raw
        } else if (raw.toJS) {
            raw = raw.toJS()
        }

        if (!_.isArray(raw)) {
            return null
        }

        return this.new(...raw)
    }
}


export let HashTag = {
    new: function(title, deepLink) {
        return {
            title,
            deepLink,

            follow: function() {
                this.deepLink.follow()
            },

            serialize: function() {
                return {
                    title: this.title,
                    link: this.deepLink.serialize()
                }
            },

            url: function() {
                return this.deepLink.url()
            },

            path: function() {
                return this.deepLink.path()
            },

            isCurrentItinerary: function() {
                return this.deepLink.isCurrentItinerary()
            }
        }
    },

    parse: function(raw) {
        if (raw.follow) {
            // this is already a deeplink object
            return raw
        } else if (raw.toJS) {
            // this is an immutable object
            raw = raw.toJS()
        }

        // by now we should have something we can work with
        if (!raw.link || !raw.title) {
            // not sure what this is
            return null
        }

        let deepLink = DeepLink.parse(raw.link)
        if (!deepLink) {
            return null
        }

        return this.new(raw.title, deepLink)
    }
}
